// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_bk-4";
export var collapsed = "_bk-1";
export var headerBar = "_bk-0";
export var leftHeaderContent = "_bk-3";
export var subjectContainer = "_bk-2";